import React from "react";
import ArrowDown from "/assets/ArrowDown.svg";
import ReactDOM from "react-dom";

const ShowData = ({
  polesData,
  selectedPole,
  isDropdownVisible,
  toggleDropdownVisibility,
  handlePoleSelection,
  handleConfirmSelection,
  setShowData,
}) => {
  return ReactDOM.createPortal(
    <div className="selectModel">
      <div className="selectContainer">
        <p>เลือกเสาที่ต้องการแสดงข้อมูล</p>
        <div
          className={`checkPoleClassName ${selectedPole || isDropdownVisible ? "selected" : ""}`}
          onClick={toggleDropdownVisibility}
        >
          <label>{selectedPole ? selectedPole.name : "รหัสเสา ชื่อเสา"}</label>
          <div>
            <img
              className={`arrow-icon-branch ${isDropdownVisible ? "rotated" : ""}`}
              src={ArrowDown}
              alt="Arrow"
            />
          </div>
          {isDropdownVisible && (
            <div className="dropdown-content-weather">
              <ul>
                {polesData.map((pole, index) => (
                  <li key={index} onClick={() => handlePoleSelection(pole)}>
                    {pole.name}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="buttonCC">
          <button className="cancel-button" onClick={() => setShowData(false)}>
            ยกเลิก
          </button>
          <button className="confirm-button" onClick={handleConfirmSelection}>
            ตกลง
          </button>
        </div>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default ShowData;
